import script from "./SpreadReading.vue?vue&type=script&setup=true&lang=js"
export * from "./SpreadReading.vue?vue&type=script&setup=true&lang=js"

import "./SpreadReading.vue?vue&type=style&index=0&id=e3c47d8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3c47d8c"]])

export default __exports__